import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrl: './sub-header.component.scss',
  standalone: false
})
export class SubHeaderComponent {
  @Input() headerSize: 'h3' | 'h5' = 'h3';
  @Input({ required: true }) text: string = '';
}
